// @ vendors
const moment = require('moment');
const actionTypes = require('constants/actionTypes');
const { DATE_FORMAT_API } = require('constants/index');
const { APIPost } = require('utilities/APIRequestHelper');
const { requestCards } = require('actions/getMyCards');
const { Promise } = require('es6-promise');

function requestCardStatementsRequest(cardId) {
    return {
        type: actionTypes.FETCH_CARDS_STATEMENTS_REQUEST,
        payload: {
            cardId
        }
    };
}

function requestCardMoreStatementsRequest(cardId) {
    return {
        type: actionTypes.FETCH_CARDS_STATEMENTS_LOAD_MORE_REQUEST,
        payload: {
            cardId
        }
    };
}

function requestCardMoreStatementsFailure(cardId, error) {
    return {
        type: actionTypes.FETCH_CARDS_STATEMENTS_LOAD_MORE_FAILURE,
        payload: {
            cardId,
            error
        }
    };
}

function requestCardMoreStatementsSuccess(cardId, data) {
    return {
        type: actionTypes.FETCH_CARDS_STATEMENTS_LOAD_MORE_SUCCESS,
        payload: {
            cardId,
            moreData: data.indicadorMasDatos,
            nextValue: data.sigValor,
            paginationData: data.datosRepaginacion,
            statements: (data.listaExtractos && data.listaExtractos.extracto) || []
        }
    };
}

function requestCardStatementsFailure(cardId, error) {
    return {
        type: actionTypes.FETCH_CARDS_STATEMENTS_FAILURE,
        payload: {
            cardId,
            error
        }
    };
}

function requestCardStatementsSuccess(cardId, data) {
    return {
        type: actionTypes.FETCH_CARDS_STATEMENTS_SUCCESS,
        payload: {
            cardId,
            moreData: data.indicadorMasDatos,
            nextValue: data.sigValor,
            paginationData: data.datosRepaginacion,
            statements: (data.listaExtractos && data.listaExtractos.extracto) || []
        }
    };
}

function getCardStatements(dispatch, getState, cardId, paginationData = null) {
    return dispatch(requestCards())
        .then(() => {
            const immCard = getState().cards.getIn(['byId', cardId]);
            const requestData = {
                query: {
                    fechaDesde: moment().subtract('30', 'months').format(DATE_FORMAT_API),
                    fechaHasta: moment().format(DATE_FORMAT_API),
                    numeroContrato: immCard.getIn(['contract', 'number']),
                    numeroTarjeta: immCard.get('number'),
                    producto: immCard.getIn(['contract', 'product']),
                }
            };
            let successStatementsCallback = response => dispatch(requestCardStatementsSuccess(cardId, response));
            let failureStatementsCallback = error => dispatch(requestCardStatementsFailure(cardId, error));

            if (!!paginationData) {
                requestData.query = {...requestData.query, ...paginationData};
                successStatementsCallback = response => dispatch(requestCardMoreStatementsSuccess(cardId, response));
                failureStatementsCallback = error => dispatch(requestCardMoreStatementsFailure(cardId, error));
                dispatch(requestCardMoreStatementsRequest(cardId));
            } else {
                dispatch(requestCardStatementsRequest(cardId));
            }

            return APIPost({
                dispatch,
                endpoint: 'cardStatements',
                params: requestData
            })
            .then(successStatementsCallback)
            .catch(response => {
                if (!!response.error) {
                    failureStatementsCallback(response.error);
                } else {
                    throw response;
                }
            });
        });
}

function requestCardStatements(cardId) {
    return function(dispatch, getState) {
        const immStatementsObj = getState().cardsStatements;

        if (immStatementsObj.size === 0 || !immStatementsObj.get(cardId)) {
            const immStatements = immStatementsObj.get(cardId);

            if (!immStatements || (!immStatements.get('loading') && !immStatements.get('error')) ) {
                return getCardStatements(dispatch, getState, cardId);
            }
        }

        return Promise.resolve();
    }
}

function requestCardMoreStatements(cardId) {
    return function(dispatch, getState) {
        const immStatementsObj = getState().cardsStatements;
        const immStatements = immStatementsObj.get(cardId);

        if (!!immStatements) {
            if (!immStatements.get('isFetchingMore') && !immStatements.get('error')) {
                let paginationData = immStatementsObj.getIn([cardId, 'paginationData']).toJS();
                paginationData.siguienteValor = immStatementsObj.getIn([cardId, 'nextValue']);
                paginationData.sxvalue = 'R';
                return getCardStatements(dispatch, getState, cardId, paginationData);
            }
        }

        return Promise.resolve();
    }
}

module.exports = {
    requestCardMoreStatements,
    requestCardStatements,
}
